// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"Member__pc_only___2GVGf","sp_only":"Member__sp_only___3tMol","title_container":"Member__title_container___3frGs","delete_container":"Member__delete_container___2QEfH"};